import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { CheckoutConfigurationCard } from './components/checkout-configuration-card'

interface CheckoutProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const CheckoutProcessorDetailsPage = ({ processor }: CheckoutProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="checkout"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} testModeWarningKey="checkoutTestModeWarning" />
            <ProcessorMetricsCard processor={processor} />
            <CheckoutConfigurationCard processor={processor} />
        </>
    )
}

